import React from 'react';


export default function PlanningOverview() {
   return <h1>Herzlich willkommen.</h1>;
}

